<template>
    <tr>
        <td>
            <select class="input_s" :value="hour" @change="action_SelectHour">
                <option v-for="h in 24" :key="h" :value="h-1">{{ formatTime(h - 1) }}</option>
            </select>
            <select class="input_s" :value="minute" @change="action_SelectMinute">
                <option v-for="m in 12" :key="m" :value="(m-1) * 5">{{ formatTime((m - 1) * 5) }}</option>
            </select>
        </td>
        <td>
            <button class="btn btn_s btn_dgray" @click="action_RemoveItem">－ {{ $t('common.delete') }}</button>
        </td>
    </tr>
</template>

<script>
import moment from '@/util/MPMoment'

export default {
    props: {
        value: String,
        index: Number
    },
    data() {
        return {
            hour: 0,
            minute: 0
        }
    },
    watch: {
        time: {
            immediate: true,
            handler: function (newValue) {
                this.hour = newValue.hour()
                this.minute = newValue.minute()
            }
        },
    },
    computed: {
        time: function () {
            return moment(this.value, 'HH:mm')
        }
    },
    methods: {
        formatTime(minute) {
            return minute < 10 ? '0' + minute : minute;
        },
        action_RemoveItem() {
            this.$emit('removeItem', this.index)
        },
        action_SelectHour(e){
            let hour = this.formatTime(e.target.value)
            let minute = this.formatTime(this.minute)
            this.$emit('updateItem', this.index, `${hour}:${minute}`)
        },
        action_SelectMinute(e) {
            let hour = this.formatTime(this.hour)
            let minute = this.formatTime(e.target.value)
            this.$emit('updateItem', this.index, `${hour}:${minute}`)
        }
    }
}
</script>